const appDirectorHost = {
  IAT: 'https://iat-adpapps.adp.com/appDirector',
  PROD: 'https://adpapps.adp.com/appDirector'
};

const baseHost = {
  DEV: 'https://local-dss.gslb.es.oneadp.com/self-service',
  DIT: 'https://marketplace-apis-dit.oneadp.com/self-service',
  IAT: 'https://iat-partner-self-service.adp.com',
  PROD: 'https://partner-self-service.adp.com'
};

const externalHost = {
  DEV: 'https://marketplace-apis-dit.oneadp.com',
  DIT: 'https://marketplace-apis-dit.oneadp.com',
  IAT: 'https://marketplace-apis-iat.adp.com',
  PROD: 'https://marketplace-apis.adp.com'
};

const clientConfig = {
  appDirector: appDirectorHost,
  baseUrl: baseHost,
  confluenceConsentLink: 'https://confluence.es.ad.adp.com/pages/viewpage.action?spaceKey=aRP&title=Consent+Terms',
  externalUrl: externalHost
};

export const webhookUIBaseUrl = {
  DEV: 'https://static.open.dit.adp.com/marketplace-webhookui-mfe',
  DIT: 'https://static.open.dit.adp.com/marketplace-webhookui-mfe',
  IAT: 'https://static.open.iat.adp.com/marketplace-webhookui-mfe',
  PROD: 'https://static.open.adp.com/marketplace-webhookui-mfe'
};

export const webhookAppShellBaseUrl = {
  DEV: 'https://api.local.adp.com/offline',
  DIT: 'https://mkpl-proxy-web.us-east-1.marketplace-apps-dit-nonprod.aws.adp',
  IAT: 'https://marketplace-apps-iat.adp.com',
  PROD: 'https://marketplace-apps.adp.com'
};

export default clientConfig;
